// FAQ accordion
document.addEventListener('click', e => {
  const q = e.target.closest('.faq-question');
  if (q) q.parentElement.classList.toggle('open');
});

// Mobile menu
document.addEventListener('DOMContentLoaded', () => {
  const menuOpen = document.getElementById('menuOpen');
  const menuClose = document.getElementById('menuClose');
  const mobileMenu = document.getElementById('mobileMenu');

  if (menuOpen) menuOpen.addEventListener('click', () => mobileMenu.classList.add('open'));
  if (menuClose) menuClose.addEventListener('click', () => mobileMenu.classList.remove('open'));
  document.querySelectorAll('.mobile-menu a').forEach(a => {
    a.addEventListener('click', () => mobileMenu && mobileMenu.classList.remove('open'));
  });

  // Sticky CTA visibility
  const stickyCta = document.getElementById('stickyCta');
  const heroEl = document.querySelector('.hero');
  const finalCta = document.querySelector('.final-cta');

  if (stickyCta && heroEl) {
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.target === heroEl) stickyCta.classList.toggle('visible', !entry.isIntersecting);
        if (entry.target === finalCta && entry.isIntersecting) stickyCta.classList.remove('visible');
      });
    }, { threshold: 0.1 });
    observer.observe(heroEl);
    if (finalCta) observer.observe(finalCta);
  }

  // Product carousel scroll indicators
  const productsScroll = document.querySelector('.products-scroll');
  const dots = document.querySelectorAll('.scroll-dot');
  if (productsScroll && dots.length) {
    productsScroll.addEventListener('scroll', () => {
      const scrollLeft = productsScroll.scrollLeft;
      const cardWidth = productsScroll.children[0].offsetWidth + 16;
      const activeIndex = Math.round(scrollLeft / cardWidth);
      dots.forEach((dot, i) => dot.classList.toggle('active', i === activeIndex));
    });
  }

  // Cart drawer
  const cartDrawer = document.getElementById('cartDrawer');
  const cartOverlay = document.getElementById('cartOverlay');
  const cartTriggers = document.querySelectorAll('[data-cart-toggle]');
  const cartCloseBtns = document.querySelectorAll('[data-cart-close]');

  function openCart() {
    if (cartDrawer) cartDrawer.classList.add('open');
    if (cartOverlay) cartOverlay.classList.add('visible');
  }
  function closeCart() {
    if (cartDrawer) cartDrawer.classList.remove('open');
    if (cartOverlay) cartOverlay.classList.remove('visible');
  }

  cartTriggers.forEach(t => t.addEventListener('click', e => { e.preventDefault(); openCart(); refreshCart(); }));
  cartCloseBtns.forEach(b => b.addEventListener('click', closeCart));
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);
});

// Cart functionality (uses Shopify Ajax API)
async function refreshCart() {
  try {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    renderCart(cart);
    updateCartCount(cart.item_count);
    updateBogoBanner(cart);
  } catch (e) {
    console.error('Cart fetch failed', e);
  }
}

function isGrowKit(item) {
  const type = (item.product_type || '').toLowerCase();
  const title = (item.product_title || '').toLowerCase();
  return type.includes('kit') || title.includes('kit');
}

function updateBogoBanner(cart) {
  const banner = document.querySelector('[data-bogo-banner]');
  if (!banner) return;

  const kitCount = cart.items
    .filter(isGrowKit)
    .reduce((sum, item) => sum + item.quantity, 0);

  if (kitCount === 0) {
    banner.classList.remove('visible', 'unlocked');
    banner.innerHTML = '';
    return;
  }

  const remainder = kitCount % 3;

  if (remainder === 0) {
    const freeKits = kitCount / 3;
    banner.innerHTML = `
      <div class="cart-bogo-banner-icon">🎁</div>
      <div class="cart-bogo-banner-text">
        <strong>Buy 2 Get 1 Free unlocked</strong>
        ${freeKits > 1 ? `${freeKits} free kits will apply at checkout.` : 'Your free kit will apply at checkout.'}
      </div>
    `;
    banner.classList.add('visible', 'unlocked');
  } else {
    const needed = 3 - remainder;
    banner.innerHTML = `
      <div class="cart-bogo-banner-icon">🎁</div>
      <div class="cart-bogo-banner-text">
        <strong>Add ${needed} more ${needed === 1 ? 'kit' : 'kits'}</strong> for Buy 2 Get 1 Free
      </div>
    `;
    banner.classList.add('visible');
    banner.classList.remove('unlocked');
  }
}

function updateCartCount(count) {
  document.querySelectorAll('.cart-count').forEach(el => {
    el.textContent = count;
    el.style.display = count > 0 ? '' : 'none';
  });
}

function renderCart(cart) {
  const itemsEl = document.querySelector('.cart-items');
  const subtotalEl = document.querySelector('.cart-subtotal-amount');
  if (!itemsEl) return;

  if (cart.item_count === 0) {
    itemsEl.innerHTML = '<div class="cart-empty">Your cart is empty.<br><br><a href="/collections/all" class="btn btn-secondary">Continue shopping</a></div>';
    if (subtotalEl) subtotalEl.textContent = '£0.00';
    return;
  }

  itemsEl.innerHTML = cart.items.map(item => `
    <div class="cart-item" data-key="${item.key}">
      <div class="cart-item-image">${item.image ? `<img src="${item.image}" alt="">` : ''}</div>
      <div class="cart-item-details">
        <div class="cart-item-title">${item.product_title}</div>
        <div class="cart-item-price">£${(item.final_line_price / 100).toFixed(2)}</div>
        <div class="cart-item-qty">
          <button data-qty-decrease data-key="${item.key}">−</button>
          <span>${item.quantity}</span>
          <button data-qty-increase data-key="${item.key}">+</button>
        </div>
      </div>
    </div>
  `).join('');

  if (subtotalEl) subtotalEl.textContent = '£' + (cart.total_price / 100).toFixed(2);
}

async function updateQty(key, delta) {
  const res = await fetch('/cart.js');
  const cart = await res.json();
  const item = cart.items.find(i => i.key === key);
  if (!item) return;
  await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: Math.max(0, item.quantity + delta) })
  });
  // On the dedicated cart page, reload so totals, line prices and the B2G1 banner update.
  // In the drawer, refreshCart re-renders without a reload.
  const onCartPage = location.pathname === '/cart' || location.pathname.startsWith('/cart/');
  if (onCartPage) {
    location.reload();
  } else {
    refreshCart();
  }
}

// Delegated qty button handler — works for cart drawer and /cart page alike
document.addEventListener('click', e => {
  const btn = e.target.closest('[data-qty-increase], [data-qty-decrease]');
  if (!btn || !btn.dataset.key) return;
  const delta = btn.hasAttribute('data-qty-increase') ? +1 : -1;
  updateQty(btn.dataset.key, delta);
});

// Add to cart from forms
document.addEventListener('submit', async e => {
  if (!e.target.matches('.product-form')) return;
  // Let Shopify's dynamic checkout buttons (Shop Pay, Apple Pay, Google Pay, PayPal) submit natively
  if (e.submitter && e.submitter.closest('.shopify-payment-button')) return;
  e.preventDefault();
  const form = e.target;
  const formData = new FormData(form);
  try {
    const res = await fetch('/cart/add.js', { method: 'POST', body: formData });
    if (res.ok) {
      await refreshCart();
      const cartDrawer = document.getElementById('cartDrawer');
      const cartOverlay = document.getElementById('cartOverlay');
      if (cartDrawer) cartDrawer.classList.add('open');
      if (cartOverlay) cartOverlay.classList.add('visible');
    } else {
      alert('Could not add to cart. Try again.');
    }
  } catch (err) {
    console.error(err);
    alert('Could not add to cart. Try again.');
  }
});

// Initial cart count
window.addEventListener('load', refreshCart);
